// extracted by mini-css-extract-plugin
export default {"root":"CommonButton_root__EwMeh","flex":"CommonButton_flex__EIaUF","small":"CommonButton_small__yRinL"};